<div class="circle" [ngStyle]="{'background': color.valueLight}" [ngClass]="{'circle--active': selectedColor?.label === color.label}"
     (click)="onSelectColor(color)">
  <rds-icon *ngIf="selectedColor?.label === color.label" class="c-white" namespace="outlined" icon="checkmark"></rds-icon>
</div>
